<h1 mat-dialog-title>{{data.title}}</h1>
<mat-dialog-content><p [innerHtml]="data.message"></p></mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button mat-dialog-close type="button">{{data.closeLabel}}</button>
	<button [mat-dialog-close]="true" mat-raised-button color="accent">{{data.confirmLabel}}</button>
</mat-dialog-actions>
